module.exports = __webpack_public_path__ + "static/media/banner_home_big-min.e2c66b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/banner_home_big-min.jpg
// module id = 634
// module chunks = 0